export const ICON_SIZE_BY_AVATAR_SIZE_MAP = {
    "16": "12",
    "20": "12",
    "24": "16",
    "36": "20",
    "44": "24",
    "56": "24",
    "72": "32",
    "96": "48",
    "120": "48",
    "144": "48",
} as const;

export const AVATAR_SIZE_BY_ICON_SIZE_MAP = {
    "12": "16",
    "16": "24",
    "20": "36",
    "24": ["44", "56"],
    "32": "72",
    "48": ["96", "120", "144"],
} as const;

export const ONLINE_INDICATOR_SIZE_BY_AVATAR_SIZE_MAP = {
    "24": "8",
    "36": "8",
    "44": "12",
    "56": "12",
    "72": "16",
    "96": "20",
    "120": "24",
    "144": "24",
} as const;

export const COUNTER_SIZE_BY_AVATAR_SIZE_MAP = {
    "24": "8",
    "36": "12",
    "44": "16",
    "56": "16",
    "72": "20",
    "96": "24",
    "120": "24",
    "144": "24",
} as const;

export const BADGE_SIZE_BY_AVATAR_SIZE_MAP = {
    "36": "12",
    "44": "16",
    "56": "16",
    "72": "20",
    "96": "24",
    "120": "24",
    "144": "24",
} as const;

export const AVATAR_SIZE_BY_BADGE_SIZE_MAP = {
    "12": "36",
    "16": ["44", "56"],
    "20": "72",
    "24": ["96", "120", "144"],
} as const;

export const GIFT_SIZE_BY_AVATAR_SIZE_MAP = {
    "56": "28",
    "72": "36",
    "96": "48",
    "120": "56",
    "144": "72",
} as const;

export const TAG_SIZE_BY_AVATAR_SIZE_MAP = {
    "56": "20",
    "72": "20",
    "96": "24",
    "120": "24",
    "144": "24",
} as const;
